// extracted by mini-css-extract-plugin
module.exports =  {"note":"Note-kjPr__note"};